import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OvalChoiceComponent } from './oval-choice/oval-choice.component';
import { WriteInChoiceComponent } from './write-in-choice/write-in-choice.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [
    OvalChoiceComponent,
    WriteInChoiceComponent,
    WriteInChoiceComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports:[
    OvalChoiceComponent,
    WriteInChoiceComponent
  ]
})
export class ChoiceModule { }
